import React, { useEffect } from 'react'
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Link, useNavigate, useParams } from 'react-router-dom'
import { get, isEmpty } from "lodash";
import { MdNavigateNext } from 'react-icons/md'
import Swal from "sweetalert2";
import { Button, Container, Grid, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, FormControlLabel, Checkbox } from '@mui/material';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { AiFillCloseCircle } from 'react-icons/ai';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useSelector, useDispatch } from 'react-redux'
import { setEditQuestion, stateRefresh, stateValues } from '../../slices/opinionTradingSlice';
import axios from 'axios'
import moment from 'moment'
import Paper from '@mui/material/Paper';
import Skelton from '../../common/Skelton';
import { PREDICTION, PREDICTION_CANCEL, PREDICTION_CHANGE_STATUS, PREDICTION_DISTRIBUTE_WINNING, PREDICTION_FORCE_CANCEL, PREDICTION_WINNING_SET } from '../../constant/endpoint';
import { useStyles } from '../../constant/constant';
import PredictionNvigation from '../../components/PredictionNvigation';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    height: '85%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    padding: '0px 30px',
    overflow: "auto",
    paddingBottom: "20px"
};


const OpinionPro = () => {
    const { match_id, series_id, sport } = useParams()
    const [open, setOpen] = React.useState(false);
    const [opinionProList, setOpinionProList] = React.useState([]);
    const [imageofQustion, setImageofQustion] = React.useState(undefined);
    const [value, setValue] = React.useState('1');
    const [sort, setSort] = React.useState({});
    const [Loading, setLoading] = React.useState(false);
    const [apiWork, setApiWork] = React.useState(false);
    const classes = useStyles();
    const navigate = useNavigate();
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const imageFile = (e) => {
        const file = e.target.files[0]
        setImageofQustion(file)
    }
    const handleOpen = () => {
        dispatch(stateRefresh())
        dispatch(stateValues({ name: 'slots_per_user', value: 2 }))
        setOpen(true)
        setApiWork(false)
        dispatch(stateValues({ name: 'predic_start_time', value: `${moment().format("YYYY-MM-DD")}T${moment().format("HH:mm")}` }))
    };
    const handleClose = () => setOpen(false);
    const dispatch = useDispatch();
    const predictionState = useSelector((state) => state.opinionTrading);


    useEffect(() => {
        getOpinionTrading()
    }, [])

    const getOpinionTrading = async () => {
        setLoading(true)
        const response = await axios.get(PREDICTION.replace(':match_id', match_id).replace(':series_id', series_id))
        if (response?.data?.status) {
            setLoading(false)
            setOpinionProList(response.data.data.filter((data) => data.is_subjective))
        }
    }


    const setQuestion = (e) => {
        dispatch(stateValues({ name: e.target.name, value: e.target.value }))
    }

    const onChangeInputText = (e) => {
        const { name, value } = e.target
        dispatch(stateValues({ name, value }))
    }
    // Alert Function
    const getSweetAlert = (type, topic) => {
        Swal.fire({
            position: 'top-end',
            icon: type,
            title: topic,
            showConfirmButton: false,
            timer: 3000
        })
    }


    const submit = async () => {
        if (IsValidation()) {
            await submitQuestion()
        }
    }

    const submitQuestion = async () => {
        setApiWork(true)
        const formData = new FormData()
        let data = {
            ...predictionState.questionStates,
            match_id,
            series_id,
            predic_start_time: moment(predictionState.questionStates.predic_start_time).utc().format(),
            predic_end_time: moment(predictionState.questionStates.predic_end_time).utc().format(),
            isEdit: true,
            is_subjective: true,
        }
        delete data.status
        formData.append('image', imageofQustion);
        formData.append('data', JSON.stringify(data));
        let result;

        if (predictionState.questionStates.isEdit) {
            result = await axios.patch(PREDICTION.replace(':match_id', match_id).replace(':series_id', series_id), formData)
        } else {
            result = await axios.post(PREDICTION.replace(':match_id', match_id).replace(':series_id', series_id), formData)
        }

        if (result?.data?.status === 'success') {
            setApiWork(false)
            if (!predictionState.isEdit) {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Question Successfully Added',
                    showConfirmButton: false,
                    timer: 1500
                })
            } else {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Question Successfully Edit',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        }
        getOpinionTrading()
        handleClose()
    }
    const IsValidation = () => {
        let status = true
        const data = predictionState.questionStates
        if (isEmpty(data.question_english)) {
            status = false
            getSweetAlert('error', 'Enter the question')
        } else if (!(data.entry_fee > 0)) {
            status = false
            getSweetAlert('error', 'Entry Free  Required')
        } else if (!(data.slots > 0)) {
            status = false
            getSweetAlert('error', 'Total Slot Required')
        } else if (Number(data.slots_per_user) > 2) {
            status = false
            getSweetAlert('error', 'User Slot can be either 1 or 2')
        } else if (data.slots_per_user <= 0) {
            status = false
            getSweetAlert('error', 'Enter Slot Per user')
        } else if (Number(data.slots) > 100 || Number(data.slots_per_user > data.slots)) {
            status = false
            getSweetAlert('error', 'Total slot not more than user slot and not more than 100')
        }
        else if (isEmpty(data.predic_start_time)) {
            status = false
            getSweetAlert('error', 'Start Time Must Be More Than Present Time')

        } else if (isEmpty(data.predic_end_time) || (moment(data.predic_end_time).format("YYYY-MM-DD, HH:mm") < moment(data.predic_start_time).format("YYYY-MM-DD, HH:mm"))) {
            status = false
            getSweetAlert('error', 'End Time Must be Larger Than Start Time')
        } else if (Number(data.admin_commission) < 10) {
            status = false
            getSweetAlert('error', 'Admin Commission Not Less Than 10')
        }
        return status
    }
    const editQuestion = (data) => {
        setOpen(true)
        const opinionPro = {
            ...data,
            predic_start_time: `${moment(data.predic_start_time).format(
                "YYYY-MM-DD"
            )}T${moment(data.predic_start_time).format("HH:mm")}`,
            predic_end_time: `${moment(data.predic_end_time).format(
                "YYYY-MM-DD"
            )}T${moment(data.predic_end_time).format("HH:mm")}`,
            isEdit: true,
        };
        dispatch(setEditQuestion(opinionPro));
        getOpinionTrading()
    }
    const checkData = (data) => {
        let finishData;
        let opinionPro;
        finishData = opinionProList.filter((data) => data.is_finish)
        opinionPro = opinionProList.filter((data) => !data.is_finish)
        if (data === 'live') {
            return opinionPro
        } else if (data === 'finish') {
            return finishData
        }
    }
    const breadcrumbs = [
        <Link underline="hover" key="1" color="inherit" to={'/matchlist'} >
            <h4>Matchlist</h4>
        </Link>, <Link
            underline="hover"
            color="inherit"
        >
            Prediction
        </Link>, <h5>{'Opinion Pro'}</h5>
    ];
    const questionStatus = async (status, prediction_id,priceBreakup) => {
        let data;
        if (status) {
            data = { status: 0, match_id, series_id }
        } else {
            data = { status: 1, match_id, series_id }
        }
        if(!isEmpty(priceBreakup)){
            await axios.patch(PREDICTION_CHANGE_STATUS.replace(':prediction_id', prediction_id), data)
        }else{
            getSweetAlert('error','Set Breakup First')
        }
        getOpinionTrading()
    }

    const cancelPrediction = async (data, prediction_id) => {
        const answer = data.inputAnswerNumber
        console.log(answer, "--answer");
        Swal.fire({
            title: 'Confirm Your Answer',
            input: 'text',
            // inputAttributes: {
            //   autocapitalize: 'off',
            // },
            showCancelButton: true,
            confirmButtonText: 'Cancel The Match',
            showLoaderOnConfirm: true,

            preConfirm: async (login) => {
                if (+login !== +answer) {
                    getSweetAlert('error', 'Please Correct Answer')
                } else {
                    await axios.patch(PREDICTION_CANCEL.replace(':prediction_id', prediction_id))
                    getOpinionTrading()
                }
            }
        })
    };

    const forceCancelPrediction = async (prediction_id) => {
        const result = await Swal.fire({
            title: 'Do you want to cancel the prediction ?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (result.isConfirmed) {
            const result = await axios.patch(
                PREDICTION_FORCE_CANCEL.replace(':prediction_id', prediction_id)
            );
            if (result?.data?.status === 'success') {
                getOpinionTrading()
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Prediction Cancel successfully",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        }
    }

    const winningDistribution = async (data) => {
        const resultCheck = await Swal.fire({
            title: `Do you want Winning Distribute?`,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (resultCheck.isConfirmed) {
            Swal.fire({
                title: 'Wait !',
                text: 'While We are distributing the winning',
                imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
                imageWidth: 400,
                imageHeight: 200,
                imageAlt: 'Custom image',
                showConfirmButton: false,
                allowOutsideClick: false
            })
            const result = await axios.patch(
                PREDICTION_DISTRIBUTE_WINNING.replace(':id', data._id)
            );
            if (result?.data?.status === 'success') {
                getOpinionTrading()
                Swal.close()
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Winning Distribution successfully",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        }
    };
    const setWinning = async (data) => {

        const resultCheck = await Swal.fire({
            title: `Do you want Winning set?`,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        })
        if (resultCheck.isConfirmed) {
            Swal.fire({
                title: 'Wait !',
                text: 'While We are setting the winning',
                imageUrl: 'https://cdn.dribbble.com/users/164889/screenshots/1192618/loading-red-spot.gif',
                imageWidth: 400,
                imageHeight: 200,
                imageAlt: 'Custom image',
                showConfirmButton: false,
                allowOutsideClick: false
            })
            const result = await axios.post(
                PREDICTION_WINNING_SET,
                data
            );
            if (result?.data?.status === "success") {
                getOpinionTrading()
                Swal.close()
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Winning set successfully",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        }
    };
    const handleSortingInput = (e, id) => {
        if (e.target.value) {
            setSort(prevValue => ({ ...prevValue, [id]: { sort_number: e.target.value } }))
        }
    }
    const handleShorting = async (data) => {
        const opinionPro = {
            ...data,
            predic_start_time: `${moment(data.predic_start_time).format(
                "YYYY-MM-DD"
            )}T${moment(data.predic_start_time).format("HH:mm")}`,
            predic_end_time: `${moment(data.predic_end_time).format(
                "YYYY-MM-DD"
            )}T${moment(data.predic_end_time).format("HH:mm")}`,
            sort_number: sort[data._id]?.sort_number ? sort[data._id]?.sort_number : data.sort_number
        };
        delete opinionPro.status
        let result = await axios.patch(PREDICTION.replace(':match_id', match_id).replace(':series_id', series_id), { data: JSON.stringify(opinionPro) })

        if (result?.data?.status === 'success') {
            if (!predictionState.isEdit) {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Sorting Successfully Added',
                    showConfirmButton: false,
                    timer: 1500
                })
            } else {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Sort Add Successfully',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        }
        getOpinionTrading()
    }
    const RedirectFun = (match_id, series_id, name) => {
        navigate(`/matchlist/${name}/${match_id}/${series_id}`)
    }
    return (
        <>
            <div className="homeCard">
                <div className='subHomeCard'>
                    <Breadcrumbs
                        separator={<MdNavigateNext fontSize="small" />}
                        aria-label="breadcrumb"
                    >

                        {breadcrumbs}
                    </Breadcrumbs>
                    <div>
                        <Container container maxWidth="xl">
                            <Grid container style={{ display: "flex", justifyContent: "space-between", paddingBottom: "20px", borderBottom: "1px solid #ccc" }}>
                                <Grid item spacing={3}>
                                    <Stack spacing={{ xs: 1, sm: 2 }} direction="row" useFlexGap flexWrap="wrap" mt={2}>
                                        <Button variant={'contained'} color="primary" onClick={() => handleOpen()}>Add Questions</Button>
                                    </Stack>
                                </Grid>
                                <Grid item>
                                    <Grid container  style={{ display: "flex", justifyContent: "flex-end", paddingBottom: "20px", }}>
                                        <PredictionNvigation match_id={match_id} series_id={series_id} sport={sport} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Container>
                    </div>
                    <Box sx={{ width: '100%', typography: 'body1' }}>
                        <TabContext value={value}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <TabList onChange={handleChange} aria-label="lab API tabs example">
                                    <Tab label="LIVE" value="1" />
                                    <Tab label="RESULT" value="2" />
                                    {/* <Tab label="Move to Finish" value="2" /> */}
                                </TabList>
                            </Box>
                            <TabPanel style={{padding:"0px"}} value="1">
                                <TableContainer component={Paper} style={{ margin: "30px 0px" }}>
                                    <Table className={classes.table}  sx={{ minWidth: 650 }} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Id</TableCell>
                                                <TableCell align="left">Image</TableCell>
                                                <TableCell align="left">Question</TableCell>
                                                {/* <TableCell align="left">Slots Per User</TableCell> */}
                                                <TableCell align="center">End Time</TableCell>
                                                <TableCell align="center">Sorting</TableCell>
                                                <TableCell align="center">Answer</TableCell>
                                                <TableCell align="center">Edit</TableCell>
                                                <TableCell align="center">Status</TableCell>
                                                <TableCell align="center">Prediction</TableCell>
                                                <TableCell align="center">winning</TableCell>
                                                <TableCell align="center">Breakup</TableCell>
                                                <TableCell align="center">Info</TableCell>
                                                <TableCell align="center">User Winning</TableCell>
                                                {/* <TableCell align="center">Force Cancel</TableCell> */}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {opinionProList.filter((data) => !(data.is_finish) && !(data.is_processing)).length > 0 ? opinionProList.filter((data) => !(data.is_finish) && !(data.is_processing))?.map((data, index) => (
                                                <TableRow
                                                    key={data.name}
                                                >
                                                    <TableCell component="th" scope="row">
                                                        {index + 1}
                                                    </TableCell>
                                                    <TableCell ><img alt={data.name} style={{ width: "50px" }} src={data.image} /></TableCell>
                                                    <TableCell style={{width: "400px"}}>{data.question_english}</TableCell>
                                                    {/* <TableCell align="center">{data.slots_per_user}</TableCell> */}
                                                    <TableCell width={100} align="center">
                                                        {moment(data.predic_end_time).format("HH:mm")} <br></br>
                                                        {moment(data.predic_end_time).format("YYYY-MM-DD")}
                                                    </TableCell>
                                                    <TableCell align="left" style={{ display: "flex", background: '#ecffe2', width: "60px" }}>
                                                        <Grid container style={{ display: "flex", background: '#fff' }}>
                                                            <TextField type='number' width={'50px'} size='small' id="outlined-basic" label="Sorting" variant="outlined" style={{ fontStyle: "8px" }} onChange={(e) => handleSortingInput(e, data._id)} autocomplete="off" value={sort[data._id]?.sort_number ? sort[data._id]?.sort_number : data.sort_number} />
                                                            <Button variant='contained' color={'warning'} style={{ fontSize: "11px", width: "60px", padding: '1px' }} onClick={() => handleShorting(data)}>Update</Button>
                                                        </Grid>
                                                    </TableCell>
                                                    <TableCell align='center'>
                                                        <p>{data?.inputAnswerNumber}</p>
                                                    </TableCell>
                                                    {/* <TableCell align='center'>
                                                        <Button variant={'contained'} size={'small'} onClick={() => moveQuestion(data)}>Move</Button>
                                                    </TableCell> */}
                                                    <TableCell align='center'><Button variant={'contained'} size={'small'} color={'warning'} onClick={() => editQuestion(data)}>Edit</Button></TableCell>
                                                    <TableCell align='center'><Button variant={'contained'} size={'small'} color={data.status ? 'success' : 'error'} onClick={() => questionStatus(data.status, data._id,data?.price_breakup)} disabled={data.is_finish || data.inputAnswerNumber || data.is_pred_cancel} >{data.status ? 'Active' : 'InActive'}</Button></TableCell>
                                                    <TableCell align='center'>
                                                        {
                                                            !data.status && ( data.inputAnswerNumber || data.inputAnswerNumber === 0)&&
                                                            <Button variant={'contained'} size={'small'} color={'error'}
                                                                disabled={data.is_pred_cancel}
                                                                onClick={() => (data.inputAnswerNumber !== null || data.option.some(newData => newData.isCorrect)) ? cancelPrediction(data, data._id) : alert('please submit answer')}
                                                            >Cancel</Button>
                                                        }
                                                    </TableCell>
                                                    {
                                                        (data.is_prediction_full || data.pred_confirm) && (data.inputAnswerNumber !== null || data.option.some(newData => newData.isCorrect)) && data.is_pred_cancel ?
                                                            <TableCell align='center'>
                                                                <Button variant={'contained'} size={'small'} color={'success'} onClick={() => setWinning(data)}>Set</Button>
                                                                {
                                                                    data.is_winning_set && <Button variant={'contained'} size={'small'} color={'success'} onClick={() => winningDistribution(data)}>Distribute</Button>
                                                                }

                                                            </TableCell> : <TableCell align='center'></TableCell>
                                                    }
                                                    <TableCell align='center'>
                                                        <Button variant={'contained'} size={'small'} color={!isEmpty(data.price_breakup) ? 'success' : "warning"} >
                                                            <Link to={{ pathname: `/add_breakup/prediction/${data.match_id}/${data.series_id}/${data._id}` }}>
                                                                Breakup
                                                            </Link>
                                                        </Button>
                                                    </TableCell>
                                                    <TableCell>
                                                        {
                                                            (data.pred_autocreate && data.is_prediction_full) &&
                                                            <Link style={{
                                                                outline: "none",
                                                                border: "none",
                                                                boxShadow: "0 0 2px #f49e9e",
                                                                background: "rgb(47 80 70)",
                                                                padding: "5px 10px",
                                                                color: "#fff",
                                                                fontWeight: 700,
                                                                borderRadius: 5,
                                                                fontSize: '12px'
                                                            }} to={{ pathname: `/matchlist/prediction_child/${data.match_id}/${data.series_id}/${data._id}` }}>Go</Link>
                                                        }
                                                    </TableCell>
                                                    <TableCell>
                                                        {data.is_winning_set &&
                                                            <Link style={{
                                                                textDecoration: 'none'
                                                            }} to={{ pathname: `/user_winning/${data._id}` }}><button style={{
                                                                outline: "none",
                                                                border: "none",
                                                                // boxShadow: "0 0 2px #f49e9e",
                                                                background: "#005b8f",
                                                                padding: "5px 10px",
                                                                color: "#fff",
                                                                fontWeight: 700,
                                                                borderRadius: 5,
                                                            }}>User Winning</button></Link>
                                                        }
                                                    </TableCell>
                                                    {/* <TableCell align='center'><Button variant={'contained'} size={'small'} color={'error'} disabled={data.status}
                                                        onClick={() => forceCancelPrediction(data._id)}>Force Cancel</Button></TableCell> */}
                                                </TableRow>
                                            )) : Loading ? <Skelton /> : <TableRow><TableCell colSpan={17} style={{ textAlign: "center", padding: "10px" }}><h3>Data Not Found</h3></TableCell></TableRow>}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </TabPanel>
                            <TabPanel style={{padding:"0px"}} value="2">
                                <TableContainer component={Paper} style={{ margin: "30px 0px" }}>
                                    <Table className={classes.table}  sx={{ minWidth: 650 }} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Id</TableCell>
                                                <TableCell align="left">Question</TableCell>
                                                <TableCell align="left">Slots Per User</TableCell>
                                                <TableCell align="center">End Time</TableCell>
                                                <TableCell align="center">View</TableCell>
                                                <TableCell align="center">Status</TableCell>
                                                <TableCell align="center">Cancel</TableCell>
                                                <TableCell align="center">Set</TableCell>
                                                <TableCell align="center">Info</TableCell>
                                                {/* <TableCell align="center">Force Cancel</TableCell> */}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {checkData('finish').length > 0 ? checkData('finish')?.map((data, index) => (
                                                <TableRow
                                                    key={data.name}
                                                >
                                                    <TableCell component="th" scope="row">
                                                        {index + 1}
                                                    </TableCell>
                                                    <TableCell>{data.question_english}</TableCell>
                                                    <TableCell align="center">{data.slots_per_user}</TableCell>
                                                    <TableCell align="center">{moment(data.predic_end_time).format("HH:mm")} {moment(data.predic_end_time).format("YYYY-MM-DD")}</TableCell>
                                                    <TableCell align='center'><Button variant={'contained'} size={'small'} color={'warning'} onClick={() => editQuestion(data)}>View</Button></TableCell>
                                                    <TableCell align='center'><Button variant={'contained'} size={'small'} color={'info'} disabled>Status</Button></TableCell>
                                                    <TableCell align='center'><Button variant={'contained'} size={'small'} color={'error'} disabled >Cancel</Button></TableCell>
                                                    <TableCell align='center'><Button variant={'contained'} size={'small'} color={'success'} disabled >Set</Button></TableCell>
                                                    <TableCell>
                                                        {
                                                            (data.pred_autocreate && data.is_prediction_full) &&
                                                            <Link style={{
                                                                outline: "none",
                                                                border: "none",
                                                                boxShadow: "0 0 2px #f49e9e",
                                                                background: "rgb(47 80 70)",
                                                                padding: "5px 10px",
                                                                color: "#fff",
                                                                fontWeight: 700,
                                                                borderRadius: 5,
                                                                fontSize: '12px'
                                                            }} to={{ pathname: `/matchlist/prediction_child/${data.match_id}/${data.series_id}/${data._id}` }}>Go</Link>
                                                        }
                                                    </TableCell>
                                                    {/* <TableCell align='center'><Button variant={'contained'} size={'small'} color={'error'} disabled={data.win_distribute}>Force Cancel</Button></TableCell> */}
                                                </TableRow>
                                            )) : Loading ? <Skelton /> : <TableRow><TableCell colSpan={12} style={{ textAlign: "center", padding: "10px" }}><h3>Data Not Found</h3></TableCell></TableRow>}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </TabPanel>
                        </TabContext>
                    </Box>
                </div>

            </div>

            <Modal
                open={open}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                onBackdropClick={() => setOpen(true)}
            >
                <Box sx={style} spacing={0.5} direction="row" useFlexGap flexWrap="wrap">
                    <Grid container>
                        <Grid xs={11}>
                            <h2 id="modal-title" mb={1}>{'Opinion Pro'}  Questions</h2>
                        </Grid>
                        <Grid xs={1}>
                            <Button onClick={handleClose}><AiFillCloseCircle style={{ width: "25px", height: "40px" }} /></Button>
                        </Grid>
                        <h4> {predictionState.questionStates._id && 'Pred id-'}  {predictionState?.questionStates?._id}</h4>
                    </Grid>
                    <hr />
                    <Grid container spacing={1}>
                        <Grid xs={4} item>
                            <label>Entry Fee</label>
                            <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'entry_fee'} onChange={setQuestion} value={predictionState.questionStates.entry_fee} disabled={get(predictionState, "questionStates.status") === undefined ? false : true} />
                        </Grid>
                        <Grid xs={4} item>
                            <label>Total Slots</label>
                            <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'slots'} onChange={setQuestion} value={predictionState.questionStates.slots} disabled={get(predictionState, "questionStates.status") === undefined ? false : true} />
                        </Grid>
                        <Grid xs={4} item>
                            <label>Slots Per User</label>
                            <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'slots_per_user'} onChange={(e) => (e.target.value >= 1 && e.target.value < 3) && setQuestion(e)} value={predictionState.questionStates.slots_per_user} disabled={get(predictionState, "questionStates.status") === undefined ? false : true} />
                        </Grid>
                        <Grid xs={6} item>
                            <label>Admin Per Commission</label>
                            <TextField id="outlined-basic" type='number' size={'small'} variant="outlined" name={'admin_commission'} onChange={setQuestion} value={predictionState.questionStates.admin_commission} disabled={get(predictionState, "questionStates.status") === undefined ? false : true} />
                        </Grid>
                        <Grid container ml={1} mt={1}>
                            <Grid xs={6} item>
                                <label>Start Date and Time</label>
                                <TextField type='datetime-local' id="outlined-basic" size={'small'} variant="outlined" name={'predic_start_time'} value={predictionState.questionStates.predic_start_time} onChange={setQuestion} disabled={get(predictionState, "questionStates.status") === undefined ? false : true} />
                            </Grid>
                            <Grid xs={6} item>
                                <label>End Date and Time</label>
                                <TextField type='datetime-local' id="outlined-basic" size={'small'} variant="outlined" name={'predic_end_time'} value={predictionState.questionStates.predic_end_time} onChange={setQuestion} disabled={get(predictionState, "questionStates.is_finish")} />
                            </Grid>
                        </Grid>
                        <Grid xs={6}>
                            <FormControlLabel control={<Checkbox id='pred_confirm' checked={JSON.parse(predictionState.questionStates.pred_confirm)} value={!JSON.parse(predictionState.questionStates.pred_confirm)} type='checkbox' placeholder='Entry Fee' name='pred_confirm' onChange={setQuestion} disabled={get(predictionState, "questionStates.status") === undefined ? false : true} ></Checkbox>} label="Prediction Confirm" />
                        </Grid>
                        <Grid xs={6}>
                            <FormControlLabel control={<Checkbox id='pred_autocreate' checked={JSON.parse(predictionState.questionStates.pred_autocreate)} value={!JSON.parse(predictionState.questionStates.pred_autocreate)} type='checkbox' name='pred_autocreate' onChange={setQuestion} disabled={get(predictionState, "questionStates.status") === undefined ? false : true} />} label="Prediction Autocreate" />
                        </Grid>
                        <Grid xs={12} item mt={1}>
                            <label>Write Question in English</label>
                            <TextField fullWidth id="standard-english" size={'small'} placeholder="Write Question in English" name={'question_english'} value={predictionState.questionStates.question_english} variant="outlined" onChange={setQuestion} disabled={get(predictionState, "questionStates.is_finish") || get(predictionState, "questionStates.status") === 1} />
                        </Grid>
                        <Grid xs={12} item mt={1}>
                            <label>Write Question in Hindi</label>
                            <TextField fullWidth id="standard-hindi" size={'small'} placeholder="Write Question in Hindi" name={'question_hindi'} value={predictionState.questionStates.question_hindi} variant="outlined" onChange={setQuestion} disabled={get(predictionState, "questionStates.is_finish") || get(predictionState, "questionStates.status") === 1} />
                        </Grid>
                        <>
                            {
                                predictionState.questionStates.isEdit ?
                                    <Grid xs={12} item mt={1}>
                                        <label>Answer</label>
                                        <TextField fullWidth id="standard-basic" type='number' size={'small'} placeholder="Input answers" name={'inputAnswerNumber'} value={predictionState.questionStates.inputAnswerNumber} variant="outlined" onChange={onChangeInputText} disabled={get(predictionState, "questionStates.status") || predictionState.questionStates.is_finish} />
                                    </Grid>
                                    : ''
                            }
                            <Grid xs={12} style={{ marginTop: "10px" }}>
                                <input
                                    accept="image/*"
                                    id="contained-button-file"
                                    multiple
                                    type="file"
                                    onChange={imageFile}
                                />
                            </Grid>
                            <Grid xs={9} mt={2}>
                                <Button color='error' onClick={handleClose} variant="contained">Cancel</Button>
                            </Grid>
                            <Grid xs={3} mt={2} textAlign={'right'}>
                                <Button onClick={submit} variant="contained" disabled={apiWork}>Submit</Button>
                            </Grid>
                        </>
                    </Grid>
                </Box>
            </Modal>
        </>
    )
}

export default OpinionPro